import React, { useEffect, useState, useMemo,useRef } from "react";
import { Modal, Select, Table, Spin, message, Flex, Typography, Button } from "antd";
import http from "@/utils/http";
import api from "@/utils/api";
import { BarsOutlined } from "@ant-design/icons";
import commonFn from "@/utils/commonFn";

const WireTransferModal = ({ 
  visible, 
  record, 
  onClose,
  apiType = "default",
  onSuccess 
}) => {
  const [propOptions, setPropOptions] = useState([]);
  const [propId, setPropId] = useState(undefined);
  const [loadingProps, setLoadingProps] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [detail, setDetail] = useState(null);
  const timerRef = useRef(null);
const modalTitle = apiType === "recordFundTransfer" ? "Fund Transfer" : "Wire Transfer";
  useEffect(() => {
    if (visible && record?.trustId) {
      fetchPropList(record.trustId);
    }
    if (!visible) {
      setPropOptions([]);
      setPropId(undefined);
      setDetail(null);
      setSubmitting(false);
      // 清理定时器
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    }
    // 组件卸载时清理定时器
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [visible, record?.trustId]);

  const fetchPropList = async (trustId) => {
    setLoadingProps(true);
    try {
      const params = { trustId: trustId };
      const res = await http.get(api.getPropByTrustList, { params });
      const options = (res?.data || res || []).map((item) => ({
        label: item.propName,
        value: item.propId,
      }));
      setPropOptions(options);
    } catch (err) {
      message.error("Failed to load property list");
    } finally {
      setLoadingProps(false);
    }
  };

  const fetchBankTransByProp = async (selectedPropId) => {
    if (!record?.bankTransNewId) {
      message.error("Missing bankTransNewId");
      return;
    }
    setLoadingDetail(true);
    try {
      const params = {
        bankTransNewId: record.bankTransNewId,
        propId: selectedPropId || "",
      };
      let res;
      if (apiType === "recordFundTransfer") {
        res = await http.get(api.getRecordFundTransferByProp, { params });
      } else {
        res = await http.get(api.getBankTransByProp, { params });
      }
      if (res?.msg) {
        if (res?.code === "1") {
          message.success(res.msg);
          timerRef.current = setTimeout(() => {
            onClose();
            onSuccess?.(); 
            timerRef.current = null;
          }, 2000); 
        } else {
          message.error(res.msg);
        }
      }
      setDetail(res?.data || res || null);
    } catch (err) {
      message.error(err?.message || "Failed to load bank transaction detail");
    } finally {
      setLoadingDetail(false);
      // setSubmitting(false);
    }
  };

  const handlePropChange = (value) => {
    setPropId(value);
  };

  const handleSubmit = () => {
    if (submitting) return;
    if (!propId) {
      message.warning("Please select a property first");
      return;
    }
    setSubmitting(true);
    fetchBankTransByProp(propId);
  };

  const columns = [
    {
      title: "Bank Account",
      dataIndex: "bankAccount",
      key: "bankAccount",
      render: (v) => v ?? record?.bankAccount ?? " ",
    },
    {
      title: "PPM Bank #",
      dataIndex: "bank",
      key: "bank",
      render: (v) => v ?? record?.bank ?? " ",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (v) => {
        return commonFn.amountToDollarBracketFn(v);
      },
    },
    {
      title: "BAI Code",
      dataIndex: "baiDesc",
      key: "baiDesc",
      render: (v) => v ?? record?.baiDesc ?? " ",
    },
    {
      title: "GL-Description",
      dataIndex: "glAcctTitle",
      key: "glAcctTitle",
      render: (v) => v ?? record?.glAcctTitle ?? " ",
    },
  //     apiType === "recordFundTransfer" && {
  //   title: "GL-Description",
  //   dataIndex: "glAcctTitle",
  //   key: "glAcctTitle",
  //   render: (v) => v ?? record?.glAcctTitle ?? " ",
  // },
  ];

  const dataSource = useMemo(() => {
    const mergedData = {
      key: "wireTransferDetail",
      ...(record || {}),
      ...(detail || {}),
    };
    return [mergedData];
  }, [record, detail]);

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <BarsOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
           {modalTitle}
          </Typography.Title>
        </Flex>
      }
      open={visible}
      onCancel={onClose}
      maskClosable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button key="close" onClick={onClose}>
           Close
          </Button>
          <Button 
            key="submit" 
            type="primary"
            loading={submitting}
            onClick={handleSubmit}
            disabled={!propId || submitting}
          >
            Submit
          </Button>
        </div>
      }
      width="40%"
      destroyOnClose
      centered
      styles={{
        body: {
          minHeight: "200px",
        },
      }}
    >
      <div style={{ marginBottom: 16 }}>
        <span style={{ marginRight: 8 }}>Property:</span>
        <Select
          style={{ width: 380 }}
          placeholder="Select property"
          loading={loadingProps}
          options={propOptions}
          value={propId}
          onChange={handlePropChange}
          allowClear
        />
      </div>

      <Spin spinning={loadingDetail}>
        <Flex justify="space-between" align="flex-start">
          <div className="model_top" style={{ width: "100%" }}>
            <div style={{ marginTop: "20px" }}>
              <Table
                rowClassName="table-row-gradient"
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                bordered
                size="small"
              />
            </div>
          </div>
        </Flex>
      </Spin>
    </Modal>
  );
};

export default WireTransferModal;